// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-container[data-v-4dedd466] {\n  margin-bottom: 15px;\n}\nlabel[data-v-4dedd466] {\n  display: block;\n  margin-bottom: 5px;\n}\n.inValida[data-v-4dedd466] {\n  border: 1px solid #a94442;\n}\n.mensagemDeErro[data-v-4dedd466] {\n  margin: 0 0 1% 0;\n  color: #a94442;\n  font-size: 12px;\n}\n.labelObrigatorio[data-v-4dedd466] {\n  color: #a94442;\n}\n.tip-label[data-v-4dedd466] {\n  color: #4a4a4a;\n  vertical-align: top;\n}", ""]);
// Exports
module.exports = exports;
